<mat-card appearance="outlined" [class]="className">
  <div class="hover-card-title">
    {{ title }}
    @if (showMenu) {
    <button mat-icon-button [matMenuTriggerFor]="menu" #duplicateMenuTrigger="matMenuTrigger">
      <mat-icon>more_vert</mat-icon>
    </button>
    } @if (showMenu) {
    <mat-menu #menu="matMenu" xPosition="before">
      <button mat-menu-item>
        {{ 'app.forecast.marketing.plan.summary.duplicate.component.dropdown.option' | translate }}
      </button>
    </mat-menu>
    }
  </div>
  <div (click)="clickHandler()">
    <div class="card-content">
      <button mat-mini-fab [matTooltip]="tooltipContent">
        <span class="sif sif-plus-no-bkg sif-16"></span>
      </button>
      <h6>{{ title }}</h6>
    </div>
  </div>
</mat-card>
